import moment from "moment"
import { DELIVERY_FAILED, DELIVERY_SENDING, DELIVERY_SENT } from "../models/agent-mail-store"

const TODAY = () => moment().format("DD.MM.YYYY")
const YESTERDAY = () => moment().subtract(1, "day").format("DD.MM.YYYY")

/** В списке: сегодня — время, вчера — «вчера», раньше — дата. Дата приходит как «дд.мм.гггг» */
export const formatMailDate = (date: string, time: string) => {
  if (date === TODAY()) {
    return time
  }

  if (date === YESTERDAY()) {
    return "вчера"
  }

  const parsed = moment(date, "DD.MM.YYYY")
  return parsed.isSame(moment(), "year") ? parsed.format("D MMM") : date
}

/** Разделитель дней в переписке */
export const formatDay = (date: string) => {
  if (date === TODAY()) {
    return "Сегодня"
  }

  if (date === YESTERDAY()) {
    return "Вчера"
  }

  const parsed = moment(date, "DD.MM.YYYY")
  return parsed.format(parsed.isSame(moment(), "year") ? "D MMMM" : "D MMMM YYYY")
}

export const deliveryLabel = (status: string | null, error: string | null) => {
  switch (status) {
    case DELIVERY_SENT:
      return "доставлено на сервер"
    case DELIVERY_FAILED:
      return `не доставлено${error ? `: ${error}` : ""}`
    case DELIVERY_SENDING:
      return "отправляется"
    default:
      return error ? `в очереди, повтор: ${error}` : "в очереди"
  }
}

export interface MailAgentOption {
  id: string
  name: string
  email: string | null
  isAgent: boolean
  categories: string[]
}

export interface MailOrderOption {
  id: string
  label: string
}
